import React from 'react';

type Props = {
  width: number;
  height: number;
  fill: string;
  className: string;
  style: React.CSSProperties;
};

const BiomarkerRangeSvg: React.FC<Props> = ({ width, height, fill, style, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '16'}
      height={height || '13'}
      viewBox="0 0 16 13"
      fill={fill}
      className={className}
      style={style}
    >
      <path
        d="M9.63412 11.6842C8.83731 12.8134 7.16269 12.8134 6.36589 11.6842L0.698717 3.65311C-0.236168 2.32826 0.711333 0.5 2.33283 0.5L13.6672 0.499999C15.2887 0.499998 16.2362 2.32826 15.3013 3.65311L9.63412 11.6842Z"
        fill={fill}
      />
    </svg>
  );
};

export default BiomarkerRangeSvg;
